/* The hosted legacy embed creates a same-origin frame. Style only that frame;
   HubSpot remains responsible for fields, validation, consent and submission. */
(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-gotak-intake-style]').forEach((embed) => {
      if (embed.dataset.styleInitialized) return;
      embed.dataset.styleInitialized = 'true';
      const apply = (frame) => {
        try {
          const doc = frame.contentDocument;
          if (!doc?.head || doc.getElementById('gotak-intake-style')) return;
          const link = doc.createElement('link');
          link.id = 'gotak-intake-style';
          link.rel = 'stylesheet';
          link.href = embed.dataset.gotakIntakeStyle;
          doc.head.appendChild(link);
        } catch (_) { /* A future cross-origin embed retains HubSpot's own styles. */ }
      };
      const seen = new WeakSet();
      const scan = () => embed.querySelectorAll('iframe.hs-form-iframe').forEach((frame) => {
        if (!seen.has(frame)) {
          seen.add(frame);
          frame.addEventListener('load', () => apply(frame));
        }
        apply(frame);
      });
      new MutationObserver(scan).observe(embed, { childList: true, subtree: true });
      scan();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
